module.exports = __webpack_public_path__ + "img/sen_wind.9fd0c9ac.png";